module.exports = __webpack_public_path__ + "img/first-section-1.980ffd4b.jpg";